/**
 * Parses appProperties JSON for a DynamicMediaApp playlist item and returns
 * the subtype-specific icon path (dailyLoop, calendar, or news).
 * Returns null if appProperties is missing, unparseable, or subtype unknown.
 */
export const getDynamicMediaAppIconUrl = (appProperties: string): string | null => {
    if (!appProperties) { return null; }
    try {
        const parsed = JSON.parse(appProperties);
        if (!Array.isArray(parsed.field_values)) { return null; }
        const fields: Array<any> = parsed.field_values;
        const has = (key: string) => fields.some((f: any) => f[key] != null);
        const val = (key: string): string | null => {
            const entry = fields.find((f: any) => f[key] != null);
            return entry?.[key]?.value ?? null;
        };
        // New format: MediaAppIconUrl hidden field is stored in field_values
        const iconUrl = val('MediaAppIconUrl');
        if (iconUrl) { return iconUrl; }
        // Legacy format: detect subtype from known field keys
        if (has('calendarTitle') || has('calendarView') || has('authType')) {
            return './assets/images/media-types/icons/v2/calendar-icon.svg';
        }
        if (has('newsChannels') || has('feedUrl')) {
            return './assets/images/media-types/icons/v2/news-icon.svg';
        }
        if (has('appType') || has('category')) {
            return './assets/images/media-types/icons/v2/dailyLoop-icon.svg';
        }
    } catch { /* ignore parse errors */ }
    return null;
};

export const addDarkToImageName = (imagePath) => {
    const lastDotIndex = imagePath.lastIndexOf('.');
    if (lastDotIndex === -1) {
        // No extension found, just append "dark"
        return imagePath + '-dark';
    }
    
    const nameWithoutExtension = imagePath.substring(0, lastDotIndex);
    const extension = imagePath.substring(lastDotIndex);
    
    return nameWithoutExtension + '-dark' + extension;
}